import { LadiesMain } from "../global/ladies-main"

window.closeBuyCoinsModal = () => {
    $("#coins-modal").modal("hide")
    LadiesMain.removeHashtagFromUrl("coins-modal")
}

window.successfullBuyCoinsModal = () => {
    openSubscriptionModalIfSet()
    openSubscriptionModalBuyButtonsIfSet()
}

window.redirectWithCorrectReferrer = (args) => {
    const isLoggedIn = userData.isLoggedIn
    if (!isLoggedIn && args && args.reLogin) {
        // no reLogin if not loggedIn already
        return
    }
    window.location.href = `/login?ref=${encodeURIComponent(window.location.pathname + window.location.hash)}`
}

window.openSubscriptionModalIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("success-modal")) {
        const successModal = LadiesMain._getHashtagObject()["success-modal"]
        const ownerId = LadiesMain._getHashtagObject()["owner-id"]
        const subscriptionButton = document.querySelector(`[data-content="#${successModal}"]`)
        const subscriptionModal = document.getElementById("subscriptionModal")
        if (
            subscriptionButton &&
            (subscriptionModal.style.display === "none" || subscriptionModal.style.display === "")
        ) {
            subscriptionButton.setAttribute("data-target", "#subscriptionModal")
            if (ownerId) {
                subscriptionButton.setAttribute("value", ownerId)
            }
            subscriptionButton.click()
        }
    }
}

window.openSubscriptionModalBuyButtonsIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("subscription-modal-buy-buttons")) {
        LadiesMain.removeHashtagFromUrl("subscription-modal-buy-buttons")
        const subscriptionModalBuyButtons = document.querySelector("#become-a-fan")
        if (subscriptionModalBuyButtons) {
            subscriptionModalBuyButtons.click()
        }
    }
}

window.openCoinModalIfSet = () => {
    if (LadiesMain.checkHashtagInUrl("buy-coins-modal")) {
        LadiesMain.removeHashtagFromUrl("buy-coins-modal")
        $("#coins-modal").modal("show")
    }
}

window.showPaymentModal = () => {
    const paymentState = LadiesMain._getHashtagObject()["payment_state"]
    const coinsModalPaymentProcess = document.getElementById("coins-modal-payment-processed")
    const coinsModalPaymentProcessText = document.getElementById("coins-modal-payment-processed-text")
    const coinsModalPaymentProcessHeader = document.getElementById("coins-purchase-after-header")

    if (paymentState === "payment_success") {
        const boughtCoinAmount = LadiesMain._getHashtagObject()["selected_quantity"]
        coinsModalPaymentProcessHeader.innerHTML = "Kaufvorgang erfolgreich abgeschlossen!"
        coinsModalPaymentProcessText.innerHTML = boughtCoinAmount + " Coins wurden erfolgreich aufgeladen."
    } else {
        coinsModalPaymentProcessHeader.innerHTML = "Kaufvorgang fehlgeschlagen!"
        coinsModalPaymentProcessText.innerHTML =
            "Transaktion fehlgeschlagen! Bitte versuchen Sie es erneut. Bei weiteren Problemen loggen sich sie sich aus und wieder ein oder melden sie sich direkt bei unserem Support."
    }

    coinsModalPaymentProcess.style.display = "block"
    LadiesMain.removeHashtagFromUrl("payment_state")
    LadiesMain.removeHashtagFromUrl("selected_quantity")
}

window.hidePartialPaymentModal = () => {
    const coinsModalPaymentProcess = document.getElementById("coins-modal-payment-processed")
    coinsModalPaymentProcess.style.display = "none"
}

$("#coins-modal").on("show.bs.modal", async (e) => {
    if (e.relatedTarget?.dataset["content"]) {
        const successModal = e.relatedTarget.dataset["content"].slice(1)

        if (successModal) {
            LadiesMain.addHashtagToUrl("success-modal", successModal)
        }
    }
    LadiesMain.addHashtagToUrl("coins-modal")
    hidePartialPaymentModal()

    if (LadiesMain.checkHashtagInUrl("payment_state")) {
        showPaymentModal()
    }
})

$("#coins-modal").on("hide.bs.modal", () => {
    LadiesMain.removeHashtagFromUrl("coins-modal")
    successfullBuyCoinsModal()
})

$(document).ready(() => {
    if (LadiesMain.checkHashtagInUrl("coins-modal")) {
        $("#coins-modal").modal("show")
    } else {
        $("#coins-modal").modal("hide")
    }
})
